import SuperadminDashboard from './SuperadminDashboard';

export default function ClientDashboard() {
  return <SuperadminDashboard isClient />;
}
